import FilterDashboard from './FilterDashboard';

export default FilterDashboard;

export interface FilterDashboardProps {
  onFilter?: (data: any) => void;
  filterData?: any;
}
